import DeleteIcon from "components/Icons/DeleteIcon";
import { useNewsAlertContext } from "./AlertContext";
import { INews } from "models/broadcast";

interface IProps {
  news: INews;
}

export default function Action({ news }: IProps) {
  const { showDelete } = useNewsAlertContext();

  const handleDelete = () => showDelete(news);

  return (
    <div className="flex items-center gap-x-3">
      <button onClick={handleDelete} className="rounded-ful">
        <DeleteIcon />
      </button>
    </div>
  );
}

